export default "__VITE_ASSET__B4SS7zGX__"